module.exports = {
  write: function (name, value, days, domain, path) {
      var date = new Date();
      days = days || 730; // two years
      path = path || '/';
      date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000));
      var expires = '; expires=' + date.toGMTString();
      var cookieValue = name + '=' + value + expires + '; path=' + path;
      if (domain) {
        if (domain.charAt(0) !== '.') {
          cookieValue += '; domain=.' + domain;
        } else {
          cookieValue += '; domain=' + domain;
        }
      }
      document.cookie = cookieValue;
  },
  read: function (name) {
      var allCookie = '' + document.cookie;
      var index = allCookie.indexOf(name);
      if (name === undefined || name === '' || index === -1) return '';
      var ind1 = allCookie.indexOf(';', index);
      if (ind1 == -1) ind1 = allCookie.length;
      return unescape(allCookie.substring(index + name.length + 1, ind1));
  },
  remove: function (name) {
    if (this.read(name)) {
        this.write(name, '', -1, '/');
    }
  }
};